import React from "react";
import ReactLoading from "react-loading";
import styled from "styled-components";
import { colors } from "../../theme";

const LoadingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 555;
  background-color: ${colors.blue};
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  color: white;
`;

const Loading = ({ inline }) => {
  if (inline) {
    return (
      <ReactLoading type="balls" color={"#000000"} height={32} width={32} />
    );
  } else {
    return (
      <LoadingContainer>
        <div>
          <ReactLoading type="balls" height={128} width={128} />
          Bezig met laden
        </div>
      </LoadingContainer>
    );
  }
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js